const getDefaultState = () => ({
    currentSelectedClients: null,
});

export default {
    namespaced: true,
    state: getDefaultState(),

    getters: {
        // fetch any keys from vuex
        get: state => key => state[key],

        getCurrentSelectedClients(state) {
            return state.currentSelectedClients;
        },
    },

    mutations: {
        /**
         * 
         * @format data {
         *     key: key,
         *     value: value
         * }
         */

        SET_CURRENT_SELECTED_CLIENTS(state, data) {
            state.currentSelectedClients = data;
        },

        REMOVE(state, key)
        {
            state[key] = null;
        },
    },
};
